import type { HeliaNode, HeliaNodeOptions } from '@/types/poc/helia';
import type { LibP2pWithServices } from '@/types/poc/libp2p';

export abstract class HeliaLifecycleService {
  abstract createNode(
    libp2p: LibP2pWithServices,
    options?: HeliaNodeOptions
  ): Promise<HeliaNode>;
  abstract destroyNode(node: HeliaNode): Promise<void>;
}
